export default function Description() {
  return (
    <div className="description-section">
      {/* Image Card */}
      <div className="image-card">
        <img
          src="/images/1 Edgerton Pl Maddingley-20251220T074545Z-3-001/1 Edgerton Pl Maddingley/High-15.jpg"
          alt="Home Design"
        />
      </div>

      {/* Details Card */}
      <div className="details-card">
        <h2> Premium Custom Homes, Designed Around You </h2>
        <p>
          At Aspire Homes, we believe that a home is more than just bricks and mortar—it’s where dreams take shape and memories are made. Our mission is to create modern, sustainable, and beautifully designed homes that reflect your lifestyle and aspirations.
        </p>
        <p>With years of experience in the building industry, we combine quality craftsmanship, innovative design, and personalized service to deliver homes that stand the test of time. From concept to completion, we work closely with you to ensure every detail meets your vision.</p>
        <p>
          Whether you’re building your first home, upgrading to your dream residence, or investing in property, Aspire Homes is committed to making the process seamless, transparent, and enjoyable.
Your dream home starts here. Let’s build it together.
        </p>
        <button className="contact-btn">Contact Us</button>
      </div>
    </div>
  );
}
